<template>
    <!-- 这个组件的意义？
    应该需要配合API来使用，因为手续费是可以改变的。可能还需要配合金额检查，查看
    是否一致
     -->
  <section class="block">
    <van-cell title="支付方式" class="block_header" value="微信支付" is-link>
    </van-cell>
    <div class="van-cell">
      补充说明内容
    </div>
    
    <van-submit-bar
      :price="344555"
      button-text="付款"
      class="order-submit-bar"
      @submit="pay"
    >
      <template v-slot:tip >
        <span slot="tip" >
          费用提示： 手续费0.6% 自动审核，实时反馈；
        </span>
      </template>
    </van-submit-bar>
  </section>
</template>

<script>
import { Cell, NavBar,Button,Row,Col,Field,CellGroup,Toast,Checkbox, CheckboxGroup,Icon, Popup, Picker, SubmitBar} from 'vant';
import {SlotsMixin} from '../pages/util/slots';
import _ from 'lodash';
import Vue from 'vue';
import {moneyFen} from '../pages/util/common';
Vue.use(Popup).use(NavBar).use(Icon).use(Toast)
  .use(Row).use(Col).use(Picker).use(Button).use(SubmitBar);

import {PaymentUsageList, PaymentWayList, CensusTypeList, PaymentItemExList, PaymentItemExDesc, PaymentItemEx, PaymentUsage, getLocationList, PaymentTermList, 
  PaymentTerm, TaxWay, TaxWayList, PayStatus} from '../pages/util/state_desc';

export default {
  name: 'sby-payment-bar',
  methods: {
    pay: function() {
      console.log('准备付款');
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/sby-payment-bar.vue